import { render, staticRenderFns } from "./VuesticBreadcrumbs.vue?vue&type=template&id=5949740c&scoped=true"
import script from "./VuesticBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./VuesticBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./VuesticBreadcrumbs.vue?vue&type=style&index=0&id=5949740c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5949740c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-breadcrumbs/VuesticBreadcrumbs.vue
// module id = vh2x
// module chunks = 41